import React, { useState } from 'react';
import Cropper from 'react-easy-crop';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
import styles from './ImageCropper.module.css';

const ImageCropper = ({ 
  image, 
  onCropComplete, 
  onSave,
  onCancel, 
  aspect = 1, 
  cropShape = 'rect',
  minWidth = 500,
  minHeight
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const handleCropComplete = (croppedArea, croppedAreaPixels) => {
    // Just store the crop data, don't process yet
    onCropComplete(croppedArea, croppedAreaPixels);
  };

  return (
    <div className={styles.cropperContainer}>
      <div className={styles.cropperHeader}>
        <h3>{aspect === 1 ? 'Crop Profile Picture' : 'Crop Cover Photo'}</h3>
        <button className={styles.closeButton} onClick={onCancel}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>

      <div className={styles.cropperContent}>
        <div className={styles.cropArea}>
          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            onCropChange={setCrop}
            onCropComplete={handleCropComplete}
            onZoomChange={setZoom}
            cropShape={cropShape}
            showGrid={true}
            minWidth={minWidth}
            minHeight={minHeight || minWidth}
          />
        </div>

        <div className={styles.controls}>
          <div className={styles.zoomControl}>
            <label>Zoom</label>
            <input
              type="range"
              min={1}
              max={3}
              step={0.1}
              value={zoom}
              onChange={(e) => setZoom(parseFloat(e.target.value))}
              className={styles.zoomSlider}
            />
          </div>

          <div className={styles.actionButtons}>
            <button onClick={onCancel} className={styles.cancelButton}>
              <FontAwesomeIcon icon={faTimes} />
              Cancel
            </button>
            <button onClick={onSave} className={styles.saveButton}>
              <FontAwesomeIcon icon={faCheck} />
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageCropper;